import { INSIGHT_SUMMARY_QUERY_KEY } from "@query";
import type { InsightQueryParams } from "../types";

export const INSIGHTS_QUERY_KEY = "insights" as const;

export const insightQueryKeys = {
	all: [INSIGHTS_QUERY_KEY] as const,
	list: (params: InsightQueryParams) =>
		[INSIGHTS_QUERY_KEY, "list", params] as const,
	summary: INSIGHT_SUMMARY_QUERY_KEY,
};
